import React from "react";
import { Typography, Box, makeStyles } from "@material-ui/core";
import KenColors from "../../../themes/KenColors";

const useStyles = makeStyles({
  text: {
    textAlign: "start",
    fontSize: 13,
    fontWeight: "700",
  },
  contain: {
    textAlign: "start",
    fontSize: 13,
    fontWeight: "700",
    width:'82%'
  },
  root: {
    padding: "16px 12px 16px",
    backgroundColor: KenColors.neutral20,
  },
});
export default function ThankYou() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography className={classes.text}>
        Your enquiry is submitted successfully.
      </Typography>
      <Typography className={classes.contain}>
        Our counsellors will contact you shortly. Alternatively you can reach us
        at <a href="tel:08022279927">08022279927</a> or write to us at{" "}
        <a href="mailto:jdfashion@jdindia.com">
        jdfashion@jdindia.com
        </a>
      </Typography>
    </Box>
  );
}
